export const getAvailableRewards = (rewards) =>
    rewards.filter(({ expireAt }) => !expireAt || new Date(expireAt).valueOf() > new Date().valueOf());
